export const isProxyAssigned = (record) => !!record?.leadSourceId;

export const formatProxyAssignment = (record) => {
  if (!isProxyAssigned(record)) return null;
  if (record.userEmail && record.leadSource) {
    return `${record.userEmail} (${record.leadSource})`;
  }
  return record.userEmail || String(record.leadSourceId);
};

export const formatProxyAssignmentLabel = (record) =>
  formatProxyAssignment(record) || "this lead source";

export const normalizeAssignableLeadSources = (data) => {
  if (!Array.isArray(data)) return [];
  return data.filter(
    (item) =>
      item &&
      (item._id || item.id) &&
      (item.jobName || item.username) &&
      (item.userEmail || item.email),
  );
};

export const formatAssignableLeadSourceOption = (source = {}) => {
  const id = source._id ?? source.id;
  const jobLabel =
    source.jobName || source.username || source.leadSource || "Lead source";
  const email = source.userEmail || source.email;
  const displayName = source.userName || source.name;
  const owner =
    displayName && email
      ? `${displayName} (${email})`
      : email || source.username || "Unknown user";

  return {
    label: `${jobLabel} — ${owner}`,
    value: id != null ? String(id) : undefined,
  };
};
